// extracted by mini-css-extract-plugin
export default {"root":"Kkn2B","hidden":"dH286"};